import {memo, useMemo} from 'react'
import {useUserIriFromLocation} from '../../hooks/entity/useUser'
import {Mercure} from './Mercure'

export const MercureUser = memo(() => {
  const userIri = useUserIriFromLocation()

  const topics = useMemo(() => {
    return (userIri && userIri !== 'me') ? [userIri] : []
  }, [userIri])

  return <Mercure topics={topics}/>
})
